/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react';
import { colors } from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/BarChart';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import CodeIcon from '@material-ui/icons/Code';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import FolderIcon from '@material-ui/icons/FolderOutlined';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LockOpenIcon from '@material-ui/icons/LockOpenOutlined';
import MailIcon from '@material-ui/icons/MailOutlined';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SettingsApplicationsTwoToneIcon from '@material-ui/icons/SettingsApplicationsTwoTone';
import Filter1Icon from '@material-ui/icons/Filter1';
import Filter2Icon from '@material-ui/icons/Filter2';
import Filter3Icon from '@material-ui/icons/Filter3';
import Filter4Icon from '@material-ui/icons/Filter4';
import Filter5Icon from '@material-ui/icons/Filter5';
import Filter6Icon from '@material-ui/icons/Filter6';

import { Label } from 'components';

export default [
  {
    title: 'Pages',
    pages: [
      {
        title: '主页',
        href: '/presentation',
        icon: HomeIcon,
        role: ["GUEST"]
      },
      {
        title: '基础管理',
        href: '/admin',
        role: ["SUPER"],
        icon: SettingsApplicationsTwoToneIcon,
        children: [
          {
            title: '用户管理',
            href: '/admin/users'
          },
          {
            title: 'steam秘钥',
            href: '/admin/steamtoken'
          },
          {
            title: '服务监控',
            href: '/admin/serverwatch'
          },
          {
            title: '快捷设置',
            href: '/admin/shortcut'
          },
          {
            title: '订单',
            href: '/pay/orders'
          },{
            title:"Paypal",
            href :'/pay/paypal'
          },
          {
            title: '系统日志',
            href: '/admin/systemlogs',
          },
        ]
      },
      {
        title: '原子战争',
        href: '/atomicwar',
        icon: Filter1Icon,
        role: ["AtomicWAR"],
        children: [
          {
            title: '黑名单',
            href: '/atomicwar/blacklist'
          },
          {
            title: '游戏玩家',
            href: '/atomicwar/steamplayers'
          },
          {
            title: '禁用列表',
            href: '/atomicwar/bannedhero'
          },
          {
            title: '生成激活码',
            href: '/atomicwar/activecode'
          },
          {
            title: '商城兑换码',
            href: '/atomicwar/shopTicket'
          },
          {
            title: '充值查询',
            href: '/atomicwar/recharge/retrive'
          },
          {
            title: '充值统计',
            href: '/atomicwar/recharge/statis'
          },
          {
            title: '前100',
            href: '/atomicwar/leaderboard/top100'
          },
          {
            title: '段位统计',
            href: '/atomicwar/leaderboard/leveldetail'
          },
          {
            title: '每日汇总',
            href: '/atomicwar/statis/dailyreport',
          },
          {
            title: '商店汇总',
            href: '/atomicwar/statis/shopdailyreport',
          },
          {
            title: '数据修复',
            href: '/atomicwar/batchfix',
          },
          {
            title: '充值ip统计',
            href: '/atomicwar/ipstatis',
          },
          {
            title: '客户端IP',
            href: '/atomicwar/clientip',
          },
          {
            title: '支付平台',
            href: '/atomicwar/pay',
          },
        ]
      },
      {
        title: '延魔秘境',
        href: '/ymmj',
        icon: Filter2Icon,
        role: ["YMMJ"],
        children: [
          {
            title: '游戏玩家',
            href: '/ymmj/steamplayers'
          },
          {
            title: '内测玩家',
            href: '/ymmj/testingplayers'
          },
          {
            title: '禁用列表',
            href: '/ymmj/bannedhero'
          },
          {
            title: '特殊玩家',
            href: '/ymmj/specialusers'
          },
          {
            title: '生成激活码',
            href: '/ymmj/activecode'
          },
          {
            title: '商城兑换码',
            href: '/ymmj/shopTicket'
          },
          {
            title: '充值统计',
            href: '/ymmj/recharge/statis'
          },
          {
            title: '排行榜',
            href: '/ymmj/leaderboard/top100'
          },
          {
            title: '赛季排行榜',
            href: '/ymmj/leaderboard/season'
          },
          {
            title: '每日汇总',
            href: '/ymmj/statis/dailyreport',
          },
          {
            title: '商店汇总',
            href: '/ymmj/statis/shopdailyreport',
          },
          {
            title: '局内统计',
            href: '/ymmj/statistics/match',
          },
          {
            title: '数据修复',
            href: '/ymmj/batchfix',
          },
        ]
      },
      {
        title: '术士之战',
        href: '/lw',
        icon: Filter3Icon,
        role: ["LORDWAR"],
        children: [
          {
            title: '游戏玩家',
            href: '/lw/steamplayers'
          }, 
          {
            title: '禁用列表',
            href: '/lw/bannedhero'
          }, 
          {
            title: '生成激活码',
            href: '/lw/activecode'
          },
          {
            title: '商城兑换码',
            href: '/lw/shopTicket'
          },
          {
            title: '充值统计',
            href: '/lw/recharge/statis'
          },
          {
            title: '排行榜',
            href: '/lw/leaderboard/top100'
          },
          {
            title: '赛季排行榜',
            href: '/lw/leaderboard/season'
          },
          {
            title: '每日汇总',
            href: '/lw/statis/dailyreport',
          },  
          {
            title: '商城支付',
            href: '/lw/shop',
          },
          {
            title: '数据修复',
            href: '/lw/batchfix',
          },
        ]
      },
      {
        title: 'Party',
        href: '/party',
        icon: Filter4Icon,
        role: ["PARTYGAME"],
        children: [
          {
            title: '游戏玩家',
            href: '/party/admin/steamplayers'
          },
          {
            title: '内测玩家',
            href: '/party/admin/testingplayers'
          },
          {
            title: '禁用列表',
            href: '/party/admin/bannedhero'
          },
          {
            title: '特殊玩家',
            href: '/party/admin/specialusers'
          },
          {
            title: '生成激活码',
            href: '/party/admin/activecode'
          },
          {
            title: '商城兑换码',
            href: '/party/admin/shopTicket'
          },
          {
            title: '充值统计',
            href: '/party/recharge/statis'
          },
          {
            title: '排行榜',
            href: '/party/leaderboard/top100'
          },
          {
            title: '段位统计',
            href: '/party/leaderboard/detail'
          },
          {
            title: '每日汇总',
            href: '/party/cr/statis/dailyreport',
          },
          {
            title: '商店汇总',
            href: '/party/cr/statis/shopdailyreport',
          },
          // {
          //   title: '局内统计',
          //   href: '/party/cr/statistics/match',
          // },

        ]
      },
      // {
      //   title: 'Fabric',
      //   href: '/fabric',
      //   role:["SUPER"],
      //   icon: AssignmentIcon,
      //   children:[
      //     {
      //       title: '用户管理',
      //       href: '/fabric/users'
      //     },
      //     {
      //       title: '投票',
      //       href: '/fabric/votes'
      //     },
      //     {
      //       title: '交易网络',
      //       href: '/fabric/network',
      //     },
      //   ]
      // },
      {
        title: '原子乱斗',
        href: '/bb',
        icon: Filter5Icon,
        role: ["AtomicWAR"],
        children: [
          {
            title: '黑名单',
            href: '/bb/blacklist'
          },
          {
            title: '游戏玩家',
            href: '/bb/steamplayers'
          }, 
          {
            title: '排行榜',
            href: '/bb/leaderboard'
          },
            {
            title: '存储状态',
            href: '/bb/storagestatus'
          },
          {
            title: '段位统计',
            href: '/bb/leaderboard/leveldetail'
          },
          {
            title: '每日汇总',
            href: '/bb/statis/dailyreport',
          }, 
        ]
      },
      {
        title: '幸运塔防',
        href: '/luckydefence',
        icon: Filter6Icon,
        role: ["LUCKYDEFENCE"],
        children: [
          {
            title: '游戏玩家',
            href: '/luckydefence/steamplayers'
          },
          {
            title: '内测玩家',
            href: '/luckydefence/testingplayers'
          },
          {
            title: '禁用列表',
            href: '/luckydefence/bannedhero'
          },
          {
            title: '特殊玩家',
            href: '/luckydefence/specialusers'
          },
          {
            title: '生成激活码',
            href: '/luckydefence/activecode'
          },
          {
            title: '商城兑换码',
            href: '/luckydefence/shopTicket'
          },
          {
            title: '玩家邮件',
            href: '/luckydefence/mail'
          },
           {
            title: '每日汇总',
            href: '/luckydefence/dailyreport',
          },
            {
            title: '商店汇总',
            href: '/luckydefence/statis/shopdailyreport',
          },
          {
            title: '充值统计',
            href: '/luckydefence/recentlyrecharge'
          },
          {
            title: '排行榜',
            href: '/luckydefence/leaderboard1'
          },  
          {
            title: '局内统计',
            href: '/luckydefence/statistics/match',
          },
          {
            title: '数据修复',
            href: '/luckydefence/batchfix',
          },
        ]
      },
      {
        title: '认证',
        href: '/auth',
        icon: LockOpenIcon,
        children: [
          {
            title: '登录',
            href: '/auth/login'
          },
          {
            title: '注册',
            href: '/auth/register'
          },
          {
            title: '注销',
            href: '/auth/logout'
          },
        ]
      },
      {
        title: '其它',
        href: '/admin',
        icon: NotificationsIcon,
        children: [
          {
            title: '待办事项',
            href: '/admin/todo'
          },
        ]
      },
      {
        title: 'Dashboards',
        href: '/dashboards',
        icon: DashboardIcon,
        role: ["Developer"],
        children: [
          {
            title: 'Default',
            href: '/dashboards/default'
          },
          {
            title: 'Analytics',
            href: '/dashboards/analytics'
          }
        ]
      },
      {
        title: 'Management',
        href: '/management',
        icon: BarChartIcon,
        role: ["Developer"],
        children: [
          {
            title: 'Customers',
            href: '/management/customers'
          },
          {
            title: 'Customer Details',
            href: '/management/customers/1/summary'
          },
          {
            title: 'Projects',
            href: '/management/projects'
          },
          {
            title: 'Orders',
            href: '/management/orders'
          },
          {
            title: 'Order Details',
            href: '/management/orders/1'
          }
        ]
      },
      {
        title: 'Social Feed',
        href: '/social-feed',
        icon: PeopleIcon,
        role: ["Developer"],
      },
      {
        title: 'Profile',
        href: '/profile',
        icon: PersonIcon,
        role: ["Developer"],
        children: [
          {
            title: 'Timeline',
            href: '/profile/1/timeline'
          },
          {
            title: 'Connections',
            href: '/profile/1/connections'
          },
          {
            title: 'Projects',
            href: '/profile/1/projects'
          },
          {
            title: 'Reviews',
            href: '/profile/1/reviews'
          }
        ]
      },
      {
        title: 'Project',
        href: '/projects',
        icon: FolderIcon,
        role: ["Developer"],
        children: [
          {
            title: 'Browse',
            href: '/projects'
          },
          {
            title: 'Create',
            href: '/projects/create'
          },
          {
            title: 'Overview',
            href: '/projects/1/overview'
          },
          {
            title: 'Files',
            href: '/projects/1/files'
          },
          {
            title: 'Activity',
            href: '/projects/1/activity'
          },
          {
            title: 'Subscribers',
            href: '/projects/1/subscribers'
          }
        ]
      },
      {
        title: 'Invoice',
        href: '/invoices/1',
        icon: ReceiptIcon,
        role: ["Developer"],
      },
      {
        title: 'Kanban Board',
        href: '/kanban-board',
        icon: ListAltIcon,
        role: ["Developer"],
      },
      {
        title: 'Mail',
        href: '/mail',
        icon: MailIcon,
        role: ["Developer"],
        label: () => (
          <Label
            color={colors.red[500]}
            shape="rounded"
          >
            2
          </Label>
        )
      },
      {
        title: 'Chat',
        href: '/chat',
        icon: ChatIcon,
        role: ["Developer"],
        label: () => (
          <Label
            color={colors.red[500]}
            shape="rounded"
          >
            4
          </Label>
        )
      },
      {
        title: 'Calendar',
        href: '/calendar',
        icon: CalendarTodayIcon,
        role: ["Developer"],
        label: () => <Label color={colors.green[500]}>New</Label>
      },
      {
        title: 'Settings',
        href: '/settings',
        icon: SettingsIcon,
        role: ["Developer"],
        children: [
          {
            title: 'General',
            href: '/settings/general'
          },
          {
            title: 'Subscription',
            href: '/settings/subscription'
          },
          {
            title: 'Notifications',
            href: '/settings/notifications'
          },
          {
            title: 'Security',
            href: '/settings/security'
          }
        ]
      },

      {
        title: 'Errors',
        href: '/errors',
        icon: ErrorIcon,
        role: ["Developer"],
        children: [
          {
            title: 'Error 401',
            href: '/errors/error-401'
          },
          {
            title: 'Error 404',
            href: '/errors/error-404'
          },
          {
            title: 'Error 500',
            href: '/errors/error-500'
          }
        ]
      }
    ]
  },
  {
    title: 'Support',
    role: ["Developer"],
    pages: [
      {
        title: 'Presentation',
        href: '/presentation',
        role: ["Developer"],
        icon: PresentToAllIcon
      },
      {
        title: 'Getting started',
        href: '/getting-started',
        role: ["Developer"],
        icon: CodeIcon
      },
      {
        title: 'Changelog',
        href: '/changelog',
        icon: ViewModuleIcon,
        role: ["Developer"],
        label: () => <Label color={colors.blue['500']}>v1.2.0</Label>
      }
    ]
  }
];
